import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';

import { CommonNotificationsService } from '../../services/commonnotifications/common-notifications.service';

@Component({
    selector: 'masterrequests-notifications',
    templateUrl: './masterrequests.component.html',
    standalone: false,
})
export class MasterRequestsNotificationsComponent implements OnInit {
    createdRequestDate: any;
    source: string;
    unSubscribe = new Subject<void>();

    notificationsState: BehaviorSubject<{
        eventTypesList: {
            id: string;
            displayName: string;
        }[];
    }> = new BehaviorSubject(undefined);

    constructor(public dialog: MatDialog, private _notification: CommonNotificationsService, @Inject(MAT_DIALOG_DATA) public data: any) {}

    loadEventsDetails = eventTypes => {
        this.notificationsState.next({
            eventTypesList: eventTypes.filter(eventType => ['mapro', 'transformation'].includes(eventType.service)),
        });
    };

    closeModal = () => {
        this.dialog.closeAll();
    };

    ngOnInit() {
        this._notification.getEventTypes(
            false,
            this.loadEventsDetails,
            () => {
                //no-op
            },
            'ALL'
        );
        // this.loadEventsDetails();
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
